import { Injectable } from '@angular/core';
import { Http, Weaver, Wrapper } from '@skylab-angular-shared/core';
import { MailTemplateRepositoryBase } from '@skylab-shared/business';
export { MailTemplateRepositoryBase };

@Injectable({ providedIn: 'root'})
@Wrapper(MailTemplateRepositoryBase)
export class MailTemplateRepository {
    public constructor(
        http: Http,
        weaver: Weaver,
    ) { }
}
